module.exports = __webpack_public_path__ + "img/santander.a713418.png";